import { Component, Host, h, Prop, EventEmitter, Event, State } from '@stencil/core';

@Component({
	tag: 'type-ahead',
	styleUrl: 'type-ahead.scss',
	shadow: true,
})
export class TypeAhead {
	@Prop() name = '';
	@Prop() placeholder = '';
	@Prop() searchingText = 'Searching...';
	@Prop() noSuggestionsText = 'No Suggestions';

	@Prop() searching = false;
	@Prop() noSuggestions = false;

	@Prop() suggestions: { text: string; value: any }[] = [];

	@State() currentValue: string = '';

	@Event({ bubbles: false }) textEntered: EventEmitter<string>;
	@Event({ bubbles: false }) textCleared: EventEmitter<void>;
	@Event({ bubbles: false }) suggestionSelected: EventEmitter<any>;
	// Indicates search button click or enter keypress
	@Event({ bubbles: false }) doSearch: EventEmitter<any>;
	// @Event({ bubbles: false }) buttonClicked: EventEmitter<any>;

	handleSuggestionClick(suggestion) {
		this.currentValue = suggestion.text;
		this.suggestionSelected.emit(suggestion.value);
	}

	handleInputChange(event: InputEvent | Event) {
		let inputType = (event as InputEvent).inputType;
		if (inputType !== 'insertText' && inputType !== 'deleteContentBackward') {
			// user has clicked native 'x' clear button
			this.textCleared.emit();
		}
		let { value } = event.target as HTMLInputElement;
		this.currentValue = value;
		this.textEntered.emit(value);
	}

	searchingTextHTML() {
		return this.searching && <span class="searching-text">{this.searchingText}</span>;
	}

	noSuggestionsTextHTML() {
		return this.noSuggestions && <span class="no-results-text">{this.noSuggestionsText}</span>;
	}

	hightlightText(text: string) {
		if ('' !== this.currentValue) {
			let parts = this.currentValue.split(' ');
			parts = parts.filter(p => p !== '');
			parts.forEach(
				part => (text = text.replace(new RegExp(part, 'ig'), `<strong>${part}</strong>`)),
			);
		}
		return text;
	}

	resultDisplay() {
		return (
			!!this.suggestions.length && (
				<ul class="suggestions">
					{this.suggestions.map(suggestion => (
						<li class="suggestion-item">
							<button
								class="suggestion-button"
								onClick={event => this.handleSuggestionClick(suggestion)}
							>
								<icon-search></icon-search>
								<span innerHTML={this.hightlightText(suggestion.text)}></span>
							</button>
						</li>
					))}
				</ul>
			)
		);
	}

	render() {
		return (
			<Host>
				<div class="type-ahead-wrapper">
					<i>
						<icon-search></icon-search>
					</i>
					<input
						class="type-ahead"
						type="search"
						name={this.name}
						placeholder={this.placeholder}
						value={this.currentValue}
						onInput={event => this.handleInputChange(event)}
						onKeyPress={event => {
							if ('Enter' === event.key) {
								this.doSearch.emit(this.currentValue);
								// this.buttonClicked.emit(this.currentValue);
							}
						}}
					/>
					<button
						type="button"
						aria-label="Submit search"
						disabled={this.currentValue == '' ? true : null}
						onClick={event => {
							this.doSearch.emit(this.currentValue);
							// this.buttonClicked.emit(this.currentValue);
						}}
					>
						<span class="sr-only">Submit</span>
						<icon-search width="20px" height="20px" color="white"></icon-search>
					</button>
				</div>
				<div class="type-ahead-suggestions">
					{this.searchingTextHTML()}
					{this.noSuggestionsTextHTML()}
					{this.resultDisplay()}
				</div>
			</Host>
		);
	}
}
